import { render, staticRenderFns } from "./Rolodex.vue?vue&type=template&id=8ababb4e&scoped=true&"
import script from "./Rolodex.vue?vue&type=script&lang=js&"
export * from "./Rolodex.vue?vue&type=script&lang=js&"
import style0 from "./Rolodex.vue?vue&type=style&index=0&id=8ababb4e&lang=scss&scoped=true&"
import style1 from "./Rolodex.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ababb4e",
  null
  
)

export default component.exports